<template>
  <div class="num-grid-card">
    <div
      v-if="isTwod"
      class="num-grid-card__head"
    >
      <h2 class="num-grid-card__title">
        {{
          $store.state.language === 'en' ? 'Number grid' : 'နံပါတ်ဇယား'
        }}
      </h2>
    </div>
    <div class="num-grid-card__body">
      <div class="num-grid">
        <div
          v-for="(num, index) in allNumbers"
          v-show="generateShowOrNow(tableData, num)"
          :key="index"
          class="num-grid__cell"
          role="button"
          :tabindex="isDisabled(num) ? -1 : 0"
          :aria-disabled="isDisabled(num) ? 'true' : 'false'"
          :class="cellClass(num)"
          @click="selectNumbers(num, index)"
          @keydown.enter.prevent="selectNumbers(num, index)"
          @keydown.space.prevent="selectNumbers(num, index)"
        >
          <span class="num-grid__digit">{{ num.number }}</span>
          <div
            v-if="shouldShowProgress(num)"
            class="num-grid__track"
          >
            <div
              class="num-grid__fill"
              :class="'num-grid__fill--' + heatLevel(num)"
              :style="{ width: progressWidth(num) }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant';

export default {
  props: {
    isTwod: {
      type: Boolean,
      default: false,
    },
    tableData: Number,
    twod: Object,
    allNumbers: Array,
    onMyEvent: Function,
  },
  data() {
    return {
      numbers: [],
      selected_data: {
        amount: null,
      },
      errors: {},
    };
  },
  methods: {
    generateShowOrNow(tableData, num) {
      if (this.isTwod) return true;
      const number = parseInt(num.number, 10);
      if (tableData === 1 && number < 100) {
        return true;
      } if (tableData === 2 && number >= 100 && number < 200) {
        return true;
      } if (tableData === 3 && number >= 200 && number < 300) {
        return true;
      } if (tableData === 4 && number >= 300 && number < 400) {
        return true;
      } if (tableData === 5 && number >= 400 && number < 500) {
        return true;
      } if (tableData === 6 && number >= 500 && number < 600) {
        return true;
      } if (tableData === 7 && number >= 600 && number < 700) {
        return true;
      } if (tableData === 8 && number >= 700 && number < 800) {
        return true;
      } if (tableData === 9 && number >= 800 && number < 900) {
        return true;
      } if (tableData === 10 && number >= 900) {
        return true;
      }
      return false;
    },
    isDisabled(num) {
      return !num.isOpen
        || parseInt(num.current_amount, 10) > parseInt(num.limit_amount, 10)
        || parseInt(num.current_amount, 10) === parseInt(num.limit_amount, 10);
    },
    shouldShowProgress(num) {
      return num.isOpen
        || parseInt(num.current_amount, 10) < parseInt(num.limit_amount, 10)
        || parseInt(num.current_amount, 10) !== parseInt(num.limit_amount, 10);
    },
    fillRatio(num) {
      const c = parseInt(num.current_amount, 10) || 0;
      const l = parseInt(num.limit_amount, 10) || 1;
      return Math.min(100, Math.max(0, (c / l) * 100));
    },
    progressWidth(num) {
      return `${this.fillRatio(num)}%`;
    },
    heatLevel(num) {
      const pct = this.fillRatio(num);
      if (pct <= 50) return 'low';
      if (pct <= 75) return 'mid';
      return 'high';
    },
    cellClass(num) {
      return {
        'num-grid__cell--active': num.isSelect,
        'num-grid__cell--disabled': this.isDisabled(num),
      };
    },
    selectNumbers(num, index) {
      if (this.isDisabled(num)) {
        return;
      }
      if (this.isTwod) {
        const newNum = this.allNumbers[index].number.toString();
        const firstChar = newNum[0];
        const secondChar = newNum[1];
        let newIndex = null;

        let isBot = null;
        let isTop = null;

        if (this.twod.top_numbers) {
          isBot = this.twod.top_numbers.includes(secondChar);
          isTop = this.twod.top_numbers.includes(firstChar);
        }

        if (isBot && !isTop) {
          const botIndex = this.numbers.findIndex((obj) => obj.number.toString() === (secondChar + firstChar));
          if (botIndex !== -1) return false;
        }

        this.allNumbers[index].isSelect = !this.allNumbers[index].isSelect;

        if (isTop) {
          newIndex = this.allNumbers.findIndex((obj) => obj.number.toString() === (secondChar + firstChar));
          this.allNumbers[newIndex].isSelect = !this.allNumbers[newIndex].isSelect;
        }

        if (this.allNumbers[index].isSelect) {
          this.numbers.push(num);
          if (isTop) {
            this.numbers.push(this.allNumbers[newIndex]);
          }
        } else if (isTop) {
          this.numbers.splice(newIndex, 1);
          const topIndex = this.numbers.findIndex((obj) => obj.number.toString() === this.allNumbers[newIndex].number.toString());
          this.numbers.splice(topIndex, 1);
          const rm = this.numbers.indexOf(num);
          this.numbers.splice(rm, 1);
        } else {
          const rm = this.numbers.indexOf(num);
          this.numbers.splice(rm, 1);
        }
        this.$emit('numbers', this.numbers);
        return true;
      }
      this.allNumbers[index].isSelect = !this.allNumbers[index].isSelect;
      if (this.allNumbers[index].isSelect) {
        this.numbers.push(num);
      } else {
        const rm = this.numbers.indexOf(num);
        this.numbers.splice(rm, 1);
      }
      this.$emit('numbers', this.numbers);
      return undefined;
    },
    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
                  this.$store.state.language === 'en'
                    ? 'Go Back'
                    : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
    resultAllSelectedNumbers() {
      for (let i = 0; i < this.allNumbers.length; i += 1) {
        this.allNumbers[i].isSelect = false;
      }
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
      return newDateObject;
    },
  },
  mounted() {
    this.onMyEvent(() => {
      this.numbers = [];
      this.resultAllSelectedNumbers();
    });
  },
};
</script>
<style scoped>
.num-grid-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 0.65rem;
  margin-top: 0.5rem;
  overflow: hidden;
}

.num-grid-card__head {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 0.75rem 1rem 0.65rem;
}

.num-grid-card__title {
  color: #8b95a8;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  text-transform: uppercase;
}

.num-grid-card__body {
  padding: 0.75rem 0.65rem 0.85rem;
}

.num-grid {
  display: grid;
  gap: 0.45rem;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.num-grid__cell {
  -webkit-tap-highlight-color: transparent;
  background: #252830;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-sizing: border-box;
  color: #e8eaef;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: clamp(0.8rem, 2.8vw, 0.95rem);
  font-weight: 700;
  justify-content: center;
  min-height: 3.9rem;
  outline: none;
  padding: 0.7rem 0.2rem 0.75rem;
  text-align: center;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease, transform 0.1s ease;
}

.num-grid__cell:focus-visible {
  box-shadow: 0 0 0 2px rgba(92, 152, 255, 0.45);
}

.num-grid__cell:active:not(.num-grid__cell--disabled) {
  transform: scale(0.97);
}

.num-grid__cell--active {
  background: rgba(92, 152, 255, 0.22);
  border-color: rgba(92, 152, 255, 0.55);
  color: #fff;
}

.num-grid__cell--disabled {
  background: #32353e;
  color: #6d7588;
  cursor: not-allowed;
  opacity: 0.72;
  pointer-events: none;
}

.num-grid__digit {
  display: block;
  line-height: 1.2;
  padding: 0.1rem 0;
}

.num-grid__track {
  background: rgba(0, 0, 0, 0.35);
  border-radius: 3px;
  height: 4px;
  margin-top: 0.3rem;
  overflow: hidden;
  width: 100%;
}

.num-grid__fill {
  border-radius: 3px;
  height: 100%;
  min-width: 0;
  transition: width 0.2s ease;
}

.num-grid__fill--low {
  background: linear-gradient(90deg, #2d8a54, #3cb371);
}

.num-grid__fill--mid {
  background: linear-gradient(90deg, #b8922e, #e4c04a);
}

.num-grid__fill--high {
  background: linear-gradient(90deg, #c43d3d, #ff6b6b);
}

@media (min-width: 400px) {
  .num-grid {
    gap: 0.55rem;
  }

  .num-grid-card__body {
    padding: 0.85rem 0.75rem 1rem;
  }
}

@media (min-width: 768px) {
  .num-grid {
    gap: 0.55rem;
  }

  .num-grid__cell {
    font-size: 0.9rem;
    min-height: 3.6rem;
  }
}
</style>
